'use client';

/**
 * BOT badge — shown next to a user's name when `is_system=true`.
 * Mark of transparency: the gallery is honest about which posts are
 * system-authored vs. created by a real human.
 */
export default function BotBadge({ size = 'sm' }: { size?: 'sm' | 'md' }) {
  const small = size === 'sm';
  return (
    <span
      title="System-authored content (auto-generated by Prompt Save Bot)"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 3,
        padding: small ? '0 5px' : '2px 8px',
        background: 'rgba(56, 189, 248, 0.16)',
        color: '#0ea5e9',
        fontSize: small ? 9 : 10,
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        borderRadius: 4,
        verticalAlign: 'middle',
        lineHeight: small ? 1.6 : 1.8,
      }}
    >
      <span className="material-symbols-outlined" style={{ fontSize: small ? 10 : 12 }}>smart_toy</span>
      Bot
    </span>
  );
}
